export default __webpack_public_path__ + "static/media/Refresh-Professional-Painting-Service.ff186da4.png";